import {
    createOptionPickerBlock,
    OptionPicker,
} from '@vfde-brix-ws10/option-picker';

/**
 * Mount the option picker
 * @param container
 * @param uuid
 * @param optType
 * @param items
 * @param onChangeAction
 */
const mountOptionPicker = (container: HTMLElement, stdName, optType, items, onChangeAction: (value: string) => void, optBehavior?): OptionPicker => {
    const onChange = (event: Event) => {
        const target = event.target as HTMLInputElement;
        onChangeAction(target.value);
    };

    return createOptionPickerBlock(container, {
        items,
        optType,
        stdName,
        business: {
            onChange,
        },
    });
};

export default mountOptionPicker;
